<div class="row">
    <div class="col-md-12 mt-3">
        <h5 class="pb-1">Puede utilizar el sistema Cl@ve para iniciar sesión:</h5>
            
        <div class="row">
            <div class="col-md-12">
                <img src="assets/images/Clave.png" title="Identificación con Cl@ve - Sistema de Identificación para las Administraciones Públicas"
                        class="btn btn-outline-dark w-25 p-1" (click)="doLoginClave()" />
            </div>
        </div>
    </div>                                    
</div>

<form id="formClaveLogin" name="formClaveLogin" [action]="aClaveRequest.Url" target="_self" [method]="aClaveRequest.Metodo">
    <input type="hidden" name="country" [value]="aClaveRequest.Country" />
    <input type="hidden" [name]="aClaveRequest.RelayStateField" [value]="aClaveRequest.RelayState" />
    <input type="hidden" [name]="aClaveRequest.SamlRequestField" [value]="aClaveRequest.Request" />
</form>
